import userManager from '../Oidc/userManager'
import GymLoading from '../Components/Loading/GymLoading'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { useAppDispatch } from 'Store/selectors'
import { clearApiStates } from 'Utils/resetApiStates'

const SignOutCallbackPage = () => {
  const [t] = useTranslation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    userManager.removeUser()
    // localStorage.clear();
    userManager.clearStaleState()
    deleteUserData()
    userManager.signinRedirect({ state: { path: '/' } })
  }, [])

  const deleteUserData = async () => {
    dispatch({ type: 'clearAllStates' })
    await clearApiStates()
  }
  return <GymLoading loading={true} description={t('logOut')} />
}

export default SignOutCallbackPage
